import type { ImageLoaderProps } from 'next/image';

/**
 * Instead of using Next.js's built-in loader, this loader uses the DatoCMS imgix service
 * to resize images. This is faster and cheaper since we don't need an additional image lambda.
 * @returns string
 */
export default function datoImageLoader({
  src,
  width,
  quality = 45,
}: ImageLoaderProps) {
  if (src.includes('datocms-assets.com')) {
    const url = new URL(src);
    const params = url.searchParams;
    params.set('auto', params.getAll('auto').join(',') || 'format');
    params.set('fit', params.get('fit') || 'max');
    params.set('w', params.get('w') || width.toString());
    if (quality) {
      params.set('q', quality.toString());
    }
    return url.href;
  } else {
    // Fallback to default Next image loader
    return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`;
  }
}
